import { api, signalr, auth } from '@/f1/service';
import RuleSelector from '../Rule.Selector.i18n'
import RuleQuickSetup from '../Rule.Quick.Setup.i18n'
import RuleService from '../Rule.Service.i18n'
import RuleIP from '../Rule.IP.i18n'
import RuleCustom from '../Rule.Custom.i18n'
import RuleCountry from '../Rule.Country.i18n'
import RuleMethod from '../Rule.Method.i18n'
import LogDetail from '../../log/Log.Detail.i18n'
import _ from 'lodash'
import AgentList from '../Modules.List.i18n';
import punycode from 'punycode'
import codes from '@/f1/codes'
import { VclFacebook } from 'vue-content-loading';
import moment from 'moment-timezone'
import Bell from 'vue-notification-bell'
import ruleI18n from '../../log/rule.i18n' // 정책 번영 파일 추가
import reg from '@/f1/reg'
import { Switch as cSwitch } from '@coreui/vue'
import agent from '../service'
import VueSpeedometer from "vue-speedometer"
import FolderSet from '../FolderSet.i18n';
import 'flag-icon-css/css/flag-icon.css';
import LogList from '../../log/Log.List.i18n'

//restful api
import { webcastle_v2 as wc } from '@/f1/service/api';

//i18n_data
import _i18n_data from './i18n_data'
import i18n_data from '@/component/i18n_data';

const default_setting = () => ({ mode: 0, level: 1, limit_cpu : 90, limit_ram : 90, limit_disk : 90, resolve_cpu : 0, resolve_ram : 0, resolve_disk : 0, });
const default_user = () => ({
  block : [],
  detect : [],
  parameter: '',
  path: '',
  allow_ip : '',
  block_ip : '',
  country_code : [],
  custom_rule : '',
  use_geoip : false,
  use_method : false,
  method_control : [
    { method : 'GET', ip_list : [], is_block : false, is_mode : true },
    { method : 'POST', ip_list : [], is_block : false, is_mode : true },
    { method : 'PATCH', ip_list : [], is_block : false, is_mode : true },
    { method : 'DELETE', ip_list : [], is_block : false, is_mode : true },
    { method : 'OPTIONs', ip_list : [], is_block : false, is_mode : true },
    { method : 'PUT', ip_list : [], is_block : false, is_mode : true },
  ],
});
export default {
  props: ['is_one', 'agent_list'],
  components: { RuleCountry, RuleSelector, AgentList, RuleQuickSetup, RuleService, RuleIP, RuleCustom, VclFacebook, Bell, LogDetail, cSwitch, VueSpeedometer, FolderSet, RuleMethod, LogList },
  data: () => {
    return {
      modal_del : false,
      del_nickname : '',
      upload_policy_selected : [],
      upload_policy_data : { domains : [] },
      upload_policy_file : undefined,
      upload_policy : false,
      webcastle_alert : false,
      webcastle_alert_is_error : false,
      webcastle_alert_msg : '',
      policy_changed : false,
      // loading_selector : false,
      // v-model="setting.level"
      change_mode_value : { prev : '', new : '', temp : '' },
      change_level_value : { prev : 0, new : 0, temp : 0 },
      change_level_modal : false,
      rule_open : {},
      is_add_domain_lock : false,
      ping_th : undefined,
      info : {},
      auth,
      modal_log : false,
      modal_log_id : 0,
      modal_name : false,
      nickname_modify_modal : false,
      modify_nickname : '',
      ruleI18n,
      using_redir : '',
      explain_mode : false,
      codes,
      // 빠른 설정 관련
      ico : { width: 30, height: 30, class: 'm1' },
      quick_modal : false,
      quick_setting_status : false,
      is_first : false,
      quick_setting : {
        DRUPAL : { use : true, key : [], indeterminate : false },
        WORDPRESS : { use : true, key : [], indeterminate : false },
        JAVA : { use : true, key : [], indeterminate : false },
        IIS : { use : true, key : [], indeterminate : false },
        PHP : { use : true, key : [], indeterminate : false }
      },
      policy_list : [],
      apply_all_server: [],
      apply_confirm_modal : false,
      apply_modal : false,
      webcastle_mmdb : '',

      sel_domain : { index : 0, domain : "default", rule : [], mode : 0, level : 1, status : true, temp : false },
      policy_default : {
        block : [],
        detect : [],
        rule : [],
        mode : 0,
        level : 1,
        parameter: [],
        url: [],
        allow_ip : [],
        block_ip : [],
        custom_rule : '',
        use_method : false,
      },
      changed_status : false,
      // 아래 변수 사용 여부 확인 필요
      is_redir : false,

      explain_user_domain : false,
      domain_remove : undefined,
      policy_select : false,
      checked_policy : [],
      target_select : false,
      select_default : false,
      checkedNames : [],
      explain_level : false,
      detect : [],
      block : [],
      rule_confirm : false,
      status_confirm : false,
      explain_user_crs : false,
      // start websocket val

      sel_rule : {},
      domain : '',
      Rule : '',
      setting : {
        mode : 0,
        level : 1,
        limit_mode : false,
        limit_cpu : 90, limit_ram : 90, limit_disk : 90,
        resolve_cpu : 60, resolve_ram : 60, resolve_disk : 60,
      },
      // end websocket val
      signalr,
      // confirm : false, // for explain modal
      perPage: 50, // for log showing count
      currentPage: 1,
      totalRows: 50,
      tabIndex: 0,
      default_rule : {},
      user: { use_method : false }, // 사용자 설정
      rule_set : {},
      server : { url : "", policy_json : { domains : [] } },
      // end default
      policy: {},
      target_list: [],
      loading: true,
      domain_manage_fields : [
        { key : 'domain', label: 'Domain' },
        { key : 'status', label: 'Status' },
        { key : 'mode', label: 'Mode' },
        { key : 'level', label: 'Policy Security Level' },
        { key: 'button', label: 'Action' },
      ],
      // fields : [
      //   { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
      //   { key: 'created_at', label: 'DateTime', sortable: false, thStyle: 'width: 15%' },
      //   { key: 'remote_addr', label: 'Attacker', sortable: false, thStyle: 'width: 5%' },
      //   { key: 'severity', label: 'Risk', sortable: false, thStyle: 'width: 10%' },
      //   { key: 'message', label: 'Message', sortable: false },
      //   { key: 'ruleid', label: 'RuleID', sortable: false },
      //   { key: 'is_block', label: 'Response', sortable: false, thStyle: 'width: 15%' },
      // ],
      th : undefined,
      crs_rule : { id : 0, version : '', agent_version : '-' }, // 현재 사용중인 변경될 CRS 정책 메타 데이터
      crs_version_list : [],
      change_main_policy : false,
      target_crs_rule : { id : 0, version : '', agent_version : '-' }, // 변경될 CRS 정책 메타 데이터
    }
  },
  computed: {
    changed_fields () { return _i18n_data._changed_fields[this.i18n || 'EN'] },
    ramStatus() { return this.info.status && this.info.status.system_memory_info ? Number(this.info.status.system_memory_info.usedPercent.toFixed(0)) : 0 },
    cpuStatus() { return this.info.status && this.info.status.system_cpu_info ? this.info.status.system_cpu_info.usage * 10 : 0 },
    disckStatus() { return this.info.status && this.info.status.system_disk_info ? _.filter(this.info.status.system_disk_info.info, x => x.mountpoint && x.percent) : [] },
    runStatus() { return this.info && this.info.status && this.model.status.running == true },
    crs_rule_count() {
      return _.filter((this.crs_version_list || []), x => x.id > this.crs_rule.id).length
    },
    fields() { return _i18n_data.i18n_fields[this.i18n || 'EN']; },
    startRow () { return this.totalRows - (this.currentPage - 1) * this.perPage; },
  },
  methods: {
    async upload_policy_save() {
      try {
        let last_update_domain = ''

        if(!this.upload_policy_selected || this.upload_policy_selected.length < 1) { return this.$toastr.w(`${i18n_data._i18n_warning.policy_check[this.i18n]}`) }
        this.loading = true

        for (let l = 0; l < this.upload_policy_selected.length; l++) {
          const domain = this.upload_policy_selected[l];

          let index = _.findIndex(this.server.policy_json.domains, x => x.domain == domain)
          let policy = _.filter(this.upload_policy_data.domains, x => x.domain == domain)
          if(index < 0) {
            // 신규 생성

            if(policy.length > 0) {
              this.server.policy_json.domains.push(policy[0])
              last_update_domain = policy[0].domain
            }
            console.log('domain', domain, 'new!!!', this.loading, this.server.policy_json.domains)
            continue
          }

          // 있을 경우
          if(policy.length > 0) {
            this.server.policy_json.domains[index] = Object.assign({}, policy[0])
            last_update_domain = policy[0].domain
          }

          console.log('domain', domain, 'update', this.loading, policy, this.server.policy_json.domains[index])



        }

        console.log('this.loading', this.loading, 'last_update_domain', last_update_domain)

        this.sel_domain.domain = last_update_domain
        await this.get(true)

        this.$toastr.w(`${i18n_data._i18n_warning.policy_check_2[this.i18n]}`)

      } catch (e) {
        console.log(e)
        this.$toastr.e(`${i18n_data._i18n_error.policy_json[this.i18n]}`)
      }
        this.upload_policy_data =  { domains : [] }
        this.upload_policy_selected = []

        this.loading = false
    },
    async upload_policy_change(evt) {
      try {
        // file 은 한개임
        let data = await new Response(evt.target.files[0]).json()
        this.upload_policy_data = Object.assign({}, this.upload_policy_data, data)
      } catch (error) {
        console.log(error)
        this.$toastr.e(`${i18n_data._i18n_error.policy_json[this.i18n]}`)
        this.upload_policy = false
      }
    },
    async download_policy(){

      let dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(await this.policy_rule(this.sel_domain.rule, true));
      let tag = document.createElement('a');
      tag.setAttribute("href",     dataStr);
      tag.setAttribute("download", this.server.nickname + ".json");
      document.body.appendChild(tag); // required for firefox
      tag.click();
      tag.remove();
      return 1
    },
    line_count: function() { return this.user.custom_rule.length ? this.user.custom_rule.split(/\r\n|\r|\n/).length + 3 : 3; },
    db_update_cmd() {
      try {
        agent.Cmd("mmdb_update", this.server.id)
        this.$toastr.i(`${i18n_data._i18n_info.request_update[this.i18n]}`)
        console.log('request to agent', this.server.nickname, 'mmdb_update')
      } catch (e) { console.long(e) }
    },
    db_update_available() {
      if(!this.server.version || this.server.version.split('.').length < 2) { return false }
      let data = this.server.version.split('.')
      let year = Number(data[0].replace('v', ''))
      let month = Number(data[1])
      // console.log(year, month, 'version test')

      // return true
      // 개발 서버 이므로
      // 2021.11 버전 이거나 이상일 경우 mmdb 업데이트 가능한 에이전트
      if((year == 2021 && month >= 11) || (year > 2021)) {
        return true
      }

      // return false
    },
    set_flag(x) { return `flag-icon flag-icon-${(x || '').toLowerCase()}` },
    back_level_change() {
      this.setting.level = this.change_level_value.temp
      this.change_level_value.prev = this.change_level_value.new = this.change_level_value.temp
      console.log('recover')
    },
    toggle_depend_level() { this.$refs.RuleSelector.$children.forEach(r => r.parser_setting(true)) },
    filter_rule_open(x) {
      let obj = {}
      obj[x.key] = x.value
      this.rule_open = Object.assign({}, this.rule_open, obj)
    },
    reload() { this.get() },
    change_policy_name(x) {
      console.log('apply to ', x)
      this.sel_domain = Object.assign(this.sel_domain, { domain : x.replace(/ /g, '') })

      // 도메인 공백 제거
      this.server.policy_json.domains[_.findIndex(this.server.policy_json.domains, { domain : x })].domain = x.replace(/ /g, '')
    },
    log_view(item) {
      this.modal_log = true
      this.modal_log_id = item.id
    },
    // default function
    async nickname_modify() {
      try{
        if(!this.modify_nickname) { return this.$toastr.w(`${i18n_data._i18n_warning.name_modify[this.i18n]}`) }

        // let rs = await api.webcastle.WebCastle_Call('agent', 'update', Object.assign({}, this.server, { nickname : this.modify_nickname }));
        let rs = await wc.agent.update(Object.assign({}, this.server, { nickname : this.modify_nickname }));

        this.nickname_modify_modal = false
        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.update_failed[this.i18n]}`) }
        this.server.nickname = this.modify_nickname
        this.modify_nickname = '';
        this.$toastr.i(`${i18n_data._i18n_success.saved[this.i18n]}`)
      } catch(e) { console.log(e) }
    },
    get_max_policy() {
      try {
        let latest =  _.maxBy(this.crs_version_list, x => x.id)
        return latest && this.crs_rule && this.crs_rule.version != latest.version ? latest.version : ''
      } catch (e) { console.log(e); this.$toastr.e(`${i18n_data._i18n_error.load_error_5[this.i18n]}`); return '' }
    },
    redir_change(x) { this.is_redir = x && x.length ? true : false },
    list() {
      this.$parent.$emit('refresh')
      this.$router.push({ name : 'webcastle_agent' });
      // this.$router.push({ name: 'webcastle_modules'});
    },
    // 퀵 설정 저장 함수
    save_default(policy) {
      try {
        this.sel_domain =  Object.assign({}, this.sel_domain, policy)
        this.setting.level = policy.level
        this.user = Object.assign({}, this.user,  { block_ip : policy.block_ip, allow_ip : policy.allow_ip, path : policy.path })
        this.setting.mode = policy.mode

        // console.log(policy.rule, 'policy.rule')
        // 룰 저장 함수
        this.policy_rule(policy.rule)

        // 빠른 설정 끝
        this.quick_setting_status = false
        this.server.updated_at = moment().format('YYYY MM DD HH:mm:ss')

      } catch (e) { console.error(e) }
    },
    domain_direct_remove(item) {
      try {
        this.domain_remove = item.domain

        // 임시 도메인이면 바로 삭제
        if(item.temp) { return this.domain_manage_remove(item.domain) }

        // 만약 미저장된 정책이 있을 경우 기존 정책 삭제 안됨, 저장 완료 후 삭제할 수 있도록 유도
        if(_.filter(this.server.policy_json.domains, x => x.temp == true).length > 0) {
          return this.$toastr.w(`${_i18n_data._i18n_warning.policy_save[this.i18n]}`)
        }
        // 그게 아니면 지우는 모달 토글
        this.explain_user_domain = true
      } catch (e) { console.error(e) }
    },
    // 다른 서버 적용 함수 시작
    async multi_save() { // 설정 저장
      try{
        let policy_list = _.map(this.policy_list, r => _.find(this.server.policy_json.domains, { "domain" : r }))
        let body = { policy_list : policy_list, server_list : this.apply_all_server.map(r => r.id) }
        this.apply_all_server = []
        // let rs = await api.webcastle.WebCastle_Call('agent', 'update.policy', body);
        let rs = await wc.agent.policy(body);
        if(rs.error) { return this.$toastr.e(`${_i18n_data._i18n_error.update_failed[this.i18n]}`) }
        this.$toastr.s(`${_i18n_data._i18n_success.agent_apply[this.i18n]}`);
        this.$emit('refresh');
        this.apply_confirm_modal = false
        this.apply_modal = false
      } catch(e) { this.catch_msg(e) }
    },
    multi_remove(index) { this.apply_all_server.length < 2 ? this.apply_all_server = [] : this.apply_all_server.splice(index, 1) },
    multi_one(item) {
      try {
        if(item) {
          if(!item) { return 'no have a data' }
          // console.log(item, this.apply_all_server)
          if(item.is_del) {
            this.apply_all_server = this.apply_all_server.map(r => { if (r && r.id != item.id) { return r } }).filter( r => r != null)
          } else {
            this.apply_all_server.push(item)
          }
        }
      } catch (e) {
        console.log(e)
      }
     },
    multi_all(items) { (items || []).map(r => { r && _.filter(this.apply_all_server, { nickname : r.nickname }).length < 1 ? this.apply_all_server.push(r) : '' }) },
    multi_clear() { this.apply_all_server = [], console.log("clear") },
    catch_msg(e) { console.log(e), this.$toastr.e(!e.data ? e : (e.data.message ? e.data.message : e.statusText)) },
    // 다른 서버 적용 함수 끝
    toggle_policy($value, key) {
      // 특정 룰을 사용하지 않음
      // console.debug("is index", key)
      let rindex = _.findIndex(this.rule_set.rule, x => x.key == key);
      rindex > -1 ? this.$refs.RuleSelector.$children.forEach(r => r.policy_toggle(rindex, -1, $value)) : ''
    },
    // min required to internet explorer 10 over
    base64encode(x) { return window.btoa(encodeURIComponent(x)) },
    base64decode(x) { return decodeURIComponent(window.atob(x)) },
    filterBlank(x) { return x ? _.uniq(_.map( typeof x == typeof 'string' ? x.split('\n') : x, r => r.trim())) : [] },
    async policy_rule(rule=[], is_save=false) {
      try {

        // this.loading_selector = true
        // 레벨 alc
        // this.server.level = this.setting.level
        // this.server.mode = this.setting.mode

        // 임시 룰 삭제, 저장하지 않음
        for(var i = 0; i < this.server.policy_json.domains.length; i++){
          if(this.server.policy_json.domains[i].temp){
            delete this.server.policy_json.domains[i].temp;
            continue
          }

          // 하위 호환
          if(!this.server.policy_json.domains[i].method_control) {
            this.server.policy_json.domains[i].method_control = default_user().method_control
            continue
          }
          this.server.policy_json.domains[i].method_control.forEach(x => x.ip_list = typeof '' == typeof x.ip_list ? x.ip_list.split('\n') : x.ip_list)
        }

        console.log("update or remove", this.sel_domain.domain)
        let index = _.findIndex(this.server.policy_json.domains, { domain : this.sel_domain.domain })
        let domain = this.server.policy_json.domains[index];

        // console.log(this.setting, "setting", domain, index, this.server.policy_json.domains)
        domain.mode = this.setting.mode;
        domain.level = this.setting.level;
        domain.rule = _.uniq(rule);

        // 가장 최근에 저장한 설정이 보여지도록
        this.server.level = domain.level
        this.server.mode = domain.mode

        // 다시 룰 넣기
        this.server.policy_json.domains[index] = Object.assign({}, this.server.policy_json.domains[index], { rule : domain.rule })

        // console.debug('test', domain.mode, codes.WAF_MODE_OFF.VALUE)
        this.user.custom_rule = this.user.custom_rule;
        domain.custom_rule = this.user.custom_rule ? this.base64encode(this.user.custom_rule) : '';
        domain.redirection = this.using_redir
        // if(this.using_redir) { domain.custom_rule += `\nSecRuleUpdateActionById 901000-90000000 "t:none,log,auditlog,msg:'Custom redirection',deny,redirect:'${this.using_redir}'"` }

        console.log(this.user.block_ip, 'this.user.block_ip')

        this.user.block_ip = this.filterBlank(this.user.block_ip)
        domain.block_ip = this.user.block_ip && this.user.block_ip.length ? this.user.block_ip : [];
        this.user.block_ip = (this.user.block_ip || []).join('\n')

        this.user.allow_ip = this.filterBlank(this.user.allow_ip)
        domain.allow_ip = this.user.allow_ip && this.user.allow_ip.length ? this.user.allow_ip : [];
        this.user.allow_ip = (this.user.allow_ip || []).join('\n')

        this.user.path = this.filterBlank(this.user.path)
        domain.path = this.user.path && this.user.path.length ? this.user.path : [];
        this.user.path = (this.user.path || []).join('\n')

        this.user.parameter = this.filterBlank(this.user.parameter);
        domain.parameter = this.user.parameter && this.user.parameter.length ? this.user.parameter : [];
        this.user.parameter = (this.user.parameter || []).join('\n')

        // this.$refs._country.
        this.user.country_code = this.filterBlank(this.user.country_code);
        domain.country_code = this.user.country_code && this.user.country_code.length ? this.user.country_code : [];
        // this.user.country_code = (this.user.country_code || []).join('\n')

        domain.use_geoip = this.user.use_geoip

        // method 변환
        domain.use_method = this.user.use_method
        domain.use_method = false
        domain.method_control = this.user.method_control ? this.user.method_control : []
        domain.method_control.forEach(x => x.ip_list = typeof x.ip_list == typeof '' ? x.ip_list.split('\n') : x.ip_list)

        // 미사용중인 룰 필터링
        // console.log(domain.mode, 'domain.mode', domain.mode == codes.WAF_MODE_ON.VALUE)
        if(domain.mode == codes.WAF_MODE_ON.VALUE) {
          domain.block = this.sel_domain.block && this.sel_domain.block.length ? _.filter(this.sel_domain.block, r => _.indexOf(domain.rule, r) < 0) : [];
          this.sel_domain.block = domain.block
          domain.detect = this.sel_domain.detect && this.sel_domain.detect.length ?  _.filter(this.sel_domain.detect, r => _.indexOf(domain.rule, r) < 0) : [];
          this.sel_domain.detect = domain.detect
        } else {
          // off or detectionOnly
          domain.detect = domain.block = []
        }

        let mode = domain.mode = domain.mode == codes.WAF_MODE_ON.VALUE ? codes.WAF_MODE_ON.TEXT : (domain.mode == codes.WAF_MODE_DETECTIONONLY.VALUE ? codes.WAF_MODE_DETECTIONONLY.TEXT : codes.WAF_MODE_OFF.TEXT)
        this.server.policy_json.domains[index] = Object.assign({}, domain, { mode : mode })
        if(!this.changed_status && domain.mode != codes.WAF_MODE_OFF.VALUE) {
          // OFF 가 아니라면 사용하기 위해 On
          this.server.policy_json.status = true
          this.setting.status = this.server.policy_json.status
        }

        this.server.setting = JSON.stringify(
          {
            limit_cpu : this.setting.limit_cpu,
            limit_ram : this.setting.limit_ram,
            limit_disk : this.setting.limit_disk,
            resolve_cpu : this.setting.resolve_cpu,
            resolve_ram : this.setting.resolve_ram,
            resolve_disk : this.setting.resolve_disk,
            limit_mode : this.setting.limit_mode,
          }
        )

        console.log(this.server.policy_json, 'final')

        if(is_save) {
          this.$toastr.s(`${_i18n_data._i18n_success.download[this.i18n]}`);
          return JSON.stringify(this.server.policy_json)
        }

        this.server.policy = JSON.stringify(this.server.policy_json);
        delete this.server.token; // 토큰 삭제

        // console.log(this.user.use_method, 'final', new Date())
        // return;
        // let rs = await api.webcastle.WebCastle({ target : 'agent', cmd : 'update', body: this.server });
        let rs = await wc.agent.update(this.server);
        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.update_failed[this.i18n]}`) }

        this.$toastr.s(`${i18n_data._i18n_success.saved[this.i18n]}`);
        this.changed_status = false

        this.get(false)

        this.$parent.$emit('refresh')

        this.policy_changed = false
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText, `${i18n_data._i18n_error.save_failed[this.i18n]}`); }
      // finally {
      //   this.loading_selector = false
      // }
    },
    async status_save(a){
      try{
        this.server.policy_json.status = a;
        this.server.policy = JSON.stringify(this.server.policy_json);
        let status_data = this.server;
        delete status_data.policy_json.id
        delete status_data.policy_json.body

        // let rs = await api.webcastle.WebCastle({ target:'agent', cmd:'update', body: status_data})
        let rs = await wc.agent.update(status_data)
        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.update_failed[this.i18n]}`) }
        this.$toastr.s(`${i18n_data._i18n_success.saved[this.i18n]}`)
        this.changed_status = true
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText, `${i18n_data._i18n_error.save_failed[this.i18n]}`); }
    },
    async save() {
      // 위의 함수에서 Update 날림.
      try {
        this.$refs.RuleSelector.$children.forEach(r => r.toss_rule())
        // this.$refs.RuleSelector.toss_rule();
        this.server.token = '';

        this.server.mode = this.setting.mode
        let update_data = this.server;
        delete update_data.policy_json.id
        delete update_data.policy_json.body

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText, `${i18n_data._i18n_error.save_failed[this.i18n]}`); }
    },
    async domain_manage_remove(domain = undefined) {
      // Domain remove
      try{
        if(domain) { this.domain_remove = domain }

        let is_save = _.filter(this.server.policy_json.domains, r => r.domain == this.domain_remove && !r.temp).length > 0

        this.server.policy_json.domains = _.filter(this.server.policy_json.domains, r => r.domain != this.domain_remove)

        this.$refs._list ? this.$refs._list.refresh() : ''
        let index = _.findIndex(this.server.policy_json.domains, { domain : this.sel_domain.domain })

        // 최근 추가된 도메인으로 설정함
        // this.sel_domain = Object.assign({}, this.sel_domain, this.policy_default, this.server.policy_json.domains[this.server.policy_json.domains.length - 1])
        // console.log(this.sel_domain, this.server.policy_json.domains[this.server.policy_json.domains.length - 1].domain)

        // let mode = this.server.policy_json.domains[this.server.policy_json.domains.length - 1].mode

        // console.log(this.sel_domain.mode, 'this.sel_domain.mode', this.sel_domain.level, 'this.sel_domain.level')
        if(index > -1) {
          this.sel_domain = Object.assign({}, this.server.policy_json.domains[index])
        } else {
          this.sel_domain = Object.assign({}, this.server.policy_json.domains[this.server.policy_json.domains.length - 1])

        }

        console.log(this.sel_domain.mode, this.sel_domain.level)

        // console.log(_.filter(this.server.policy_json.domains, r => r.domain == this.domain_remove && !r.temp))
        // 이전 저장된 도매안 삭제시, 미저장 도메인은 바로 삭제
        if(is_save) {
          // 삭제된 도메인 필터
          console.log("remove & save")
          console.log(this.server.policy_json, 'final')

          this.server.policy = JSON.stringify(this.server.policy_json);
          delete this.server.token; // 토큰 삭제
          // let rs = await api.webcastle.WebCastle({ target : 'agent', cmd : 'update', body: this.server });
          let rs = await wc.agent.update(this.server);
          if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.update_failed[this.i18n]}`) }

          this.$toastr.s(`${i18n_data._i18n_success.removed[this.i18n]}`);

          this.get(false)

          this.$parent.$emit('refresh')
          // this.save();
        }


        console.log("sel domain is ", this.sel_domain.domain)
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText, `${i18n_data._i18n_error.error_code_2[this.i18n]}`); }
    },
    async domain_manage_regist(origin_domain=undefined, domain = undefined) {
      // Domain Add
      try {
        if(domain) { this.domain = domain }
        if(!this.domain) { return this.$toastr.w(`${_i18n_data._i18n_warning.domain_manage[this.i18n]}`, `${_i18n_data._i18n_warning.domain_manage_2[this.i18n]}`) }
        console.log("WTF", this.domain)
        this.domain = this.domain.replace(/ /g, '')
        console.log("WTF", this.domain)

        if(this.domain.indexOf(':') > -1 || this.domain.indexOf('\\/\\/') > -1) {
          return this.$toastr.w(`${_i18n_data._i18n_warning.domain_manage_3[this.i18n]}`)
        }
        this.is_add_domain_lock = true
        // const rs = await api.webcastle.WebCastle({target : 'agent', cmd : 'domain.limit', body : new Date().getTime()})
        const rs = await wc.agent.domainLimit(new Date().getTime())
        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.verify[this.i18n]}`) }
        // 라이선스 확인
        if(rs.body < this.server.policy_json.domains.length) { return this.$toastr.e(`${i18n_data._i18n_error.license_check[this.i18n]}`)}
        // 중복 확인
        if(_.filter(this.server.policy_json.domains, d => d.domain == this.domain).length > 0) { return this.$toastr.e(`${i18n_data._i18n_error.duplicate[this.i18n]}`); }
        // 한글 도메인 등록
        if(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(this.domain)){ this.domain = punycode.toASCII(this.domain) }

        // clone 때문에 그럼
        // console.log(this.policy_default, default_user())
        // this.server.policy_json.domains[_.findIndex(this.server.policy_json.domains, x => x.domain == origin_)]

        let new_domain = origin_domain != undefined ?
          Object.assign({}, this.policy_default, this.server.policy_json.domains[_.findIndex(this.server.policy_json.domains, x => x.domain == origin_domain)], { domain : this.domain }, { temp : true }) :
            Object.assign({}, this.policy_default, default_user(), { domain : this.domain }, { temp : true })

        // 모드 강제 설졍
        if(origin_domain != undefined) {
          // new_domain.mode = this.setting.mode == codes.WAF_MODE_ON.VALUE ?
          // codes.WAF_MODE_ON.TEXT :
          //   (this.setting.mode == codes.WAF_MODE_DETECTIONONLY.VALUE ?
          //     codes.WAF_MODE_DETECTIONONLY.TEXT :
          //       codes.WAF_MODE_OFF.TEXT)
        } else {
          new_domain.mode = origin_domain === undefined && this.policy_default.mode == codes.WAF_MODE_ON.VALUE ?
          codes.WAF_MODE_ON.TEXT :
            (this.policy_default.mode == codes.WAF_MODE_DETECTIONONLY.VALUE ?
              codes.WAF_MODE_DETECTIONONLY.TEXT :
                codes.WAF_MODE_OFF.TEXT)
        }

        // 방화벽 룰
        this.server.policy_json.domains.push(Object.assign({}, new_domain));
        this.domain = ''
        // 설정 초기화
        this.setting = origin_domain != undefined ?
          Object.assign({}, this.setting, { status : this.setting.status }) :
            Object.assign({}, default_setting(), { status : this.setting.status })
        // 새로운 도메인 적용
        this.change_domain(new_domain.domain)

        // 새로고침
        this.$refs._list ? this.$refs._list.refresh() : ''

      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText, `${_i18n_data._i18n_error.domain_failed[this.i18n]}`)
      } finally {
        this.is_add_domain_lock = false
      }
    },
    getItems(ctx) { return this.load(ctx); },
    async load() {
      // Log List
      let so = {
        // target : 'log',
        // cmd : 'list',
        offset : 0,
        limit :  50,
        body : {
          and : [ { name : "agent_id", value : Number(this.server.id), op : "=" } ],
          sort : [ { name : "id", op : "desc" } ]
        }
      }
      // return await api.webcastle.WebCastle(so).then(rs => {
      return await wc.detect.list(so).then(rs => {
        this.totalRows = rs.total;
        return _.map(rs.body, r => {
          try {
            //Todo : r.message 여부 고려해야함
            r.message && typeof '' == typeof r.message ? JSON.parse(r.message) : r.message
            // r.message = JSON.parse(r.message);
          } catch (e) { console.log("json parser failed"); r.failed = true; }

          ///해당 코드 log 에서 사용하지않습니다.///
          // 메세지 앞에 탐지한 구문이 있을 경우, 탐지만으로 설정, 패턴 N 개 매칭으로 인한 코드 추가
          // r.detect_cnt = _.filter(r.message.messages, x => _.startsWith(x.message.toLowerCase(), '[detectiononly]')).length
          // r.block_cnt = r.message.messages.length - r.detect_cnt
          // r.message = _.minBy(r.message.messages, function(x) { return Number(x.details.severity) })
          ///해당 내용 log 에서 사용하지않습니다.///

          _.forEach(r.headers ? r.headers.split('\n') : [], line => {
            let ip = line.replace(/(x-forwarded-for:| )/ig, '')
            _.startsWith(line.toLowerCase(), 'x-forwarded-for') && reg.ip4.test(ip) ? (r.remote_addr = ip) : ''
          })

          return r
        })
      }).catch(e => {
        // console.error(e)
        this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` :  e.data.message ? e.data.message : e.statusText)
      });
    },
    sync_log() {
      clearTimeout(this.th);
      if(this.tabIndex == 6) { this.$refs._list.refresh(); console.log('refresh real time') }
      this.th = setTimeout(() => { this.sync_log(); }, 5000 );
    },
    refresh() { if(!this.th) { this.sync_log(), console.log("start sync_log") } this.$refs && this.$refs._list ? this.$refs._list.refresh() : ''; },
    async change_target(s) {
      // let rs = await api.webcastle.WebCastle({target : 'agent', cmd : 'detail', body : { id : s }})
      let rs = await wc.agent.detail({ id : s })
      if(rs.error) { return this.$toastr.e(`${_i18n_data._i18n_error.agent_failed[this.i18n]}`) }
      this.$router.push({ name: 'webcastle_modules', params: { id: rs.body.id, version : 'v2' }})
      this.$toastr.i(`${_i18n_data._i18n_info.change_target[this.i18n]}`)
    },
    change_domain(domain){
      try {
        console.log("new Policy", domain, domain.version)
        if(!domain) { return this.$toastr.e(`${i18n_data._i18n_error.change_domain[this.i18n]}`) }
        this.sel_domain = Object.assign({}, _.find(this.server.policy_json.domains, { domain : domain }));
        this.sel_domain.mode = this.sel_domain.mode == codes.WAF_MODE_ON.TEXT ? 2 : (this.sel_domain.mode == codes.WAF_MODE_DETECTIONONLY.TEXT ? 1 : 0)
        this.setting.mode = this.sel_domain.mode
        this.setting.level = this.sel_domain.level
        this.change_level_value.new = this.change_level_value.prev = this.setting.level


        console.log("changed domain", this.sel_domain, this.change_level_value)

        this.user.use_geoip = this.sel_domain.use_geoip;
        this.user.country_code = this.sel_domain.country_code;
        this.user.block_ip = typeof this.sel_domain.block_ip == typeof '' ? this.sel_domain.block_ip : (this.sel_domain.block_ip || []).join('\n');
        this.user.allow_ip = typeof this.sel_domain.allow_ip == typeof '' ? this.sel_domain.allow_ip : (this.sel_domain.allow_ip || []).join('\n');
        this.user.path = typeof this.sel_domain.path == typeof '' ? this.sel_domain.path : (this.sel_domain.path || []).join('\n');
        this.user.parameter = typeof this.sel_domain.parameter == typeof '' ? this.sel_domain.parameter : (this.sel_domain.parameter || []).join('\n');
        this.user.custom_rule = this.base64decode(this.sel_domain.custom_rule);
        this.user.method_control = this.sel_domain.method_control ? this.sel_domain.method_control : default_user().method_control
        this.user.use_method = this.sel_domain.use_method;
        this.user.method_control.forEach(x => x.ip_list = typeof '' ==  typeof x.ip_list ? x.ip_list : x.ip_list.join('\n'))


        this.using_redir = this.sel_domain.redirection
        this.is_redir = this.using_redir && this.using_redir.length > 0 ? true : false

        this.change_level_value.prev = this.change_level_value.new = this.sel_domain.level
        this.change_mode_value.prev = this.change_mode_value.new = this.setting.mode

        this.filter_rule()

        this.$refs.RuleSelector.$children.forEach(x => x.parser_setting())
      } catch (e) { console.log(e); this.$toastr.e(`${i18n_data._i18n_error.load_error_1[this.i18n]}`) }
    },
    filter_rule() {
      try {
        if(moment(this.server.updated_at).valueOf() < moment('2021-11-18 00:00:00').valueOf()) {
          this.sel_domain.rule = _.compact(_.map(this.sel_domain.rule, x => {
            for (let r = 0; r < this.rule_set.rule.length; r++) {
              for (let s = 0; s < this.rule_set.rule[r].rules.length; s++) {
                if(this.rule_set.rule[r].rules[s].key != x) { continue; }

                if(this.getLevel(this.rule_set.rule[r].rules[s].paranoia_level) > this.sel_domain.level) {
                  console.log("remove policy for compatibility", x)
                  return ''
                }
                return x
              }

            }
          }))
        }
      } catch (e) {
        console.log(e)
      }
    },
    async change_crs(){ // 정책 업데이트
      try {
        this.server.crs_id = this.target_crs_rule.id

        // 해당 에이전트 버전이 최소 버전보다 작을 경우 업데이트 불가 안내
        if(this.crs_rule.agent_version && this.target_crs_rule.agent_version && Number(this.crs_rule.agent_version.replace('.','')) < Number(this.target_crs_rule.agent_version.replace('.',''))) {
          return this.$toastr.e(`${i18n_data._i18n_error.crs_check[this.i18n]}` +this.target_crs_rule.agent_version);
        }

        // let rs = await api.webcastle.WebCastle({ target : 'agent', cmd : 'update', body: this.server });
        let rs = await wc.agent.update(this.server);
        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.update_failed[this.i18n]}`) }

        this.$toastr.s(`${i18n_data._i18n_success.reload[this.i18n]}`);

        this.loading = true
        this.change_main_policy = false

        setTimeout(() => location.reload(), 2000)

      } catch (e) { console.log(e); this.$toastr.e(`${i18n_data._i18n_error.load_error_1[this.i18n]}`) }
    },
    async get_policy_version() {
      // 기본 정책 로딩
      try {
        // let rs_crs = await api.webcastle.WebCastle({ target : 'policy', cmd : 'version', body : { id : this.server.crs_id } });
        let rs_crs = await wc.policy.version({ id : this.server.crs_id });
        if(rs_crs.error) { return this.$toastr.e(`${i18n_data._i18n_error.policy_failed[this.i18n]}`) }
        this.crs_version_list = rs_crs.body
      } catch (e) { console.log(e); this.$toastr.e(`${i18n_data._i18n_error.load_error[this.i18n]}`) }
    },

    // initialize
    async get(reload=false) {
      try {
        let id = this.$route.params.id
        // 에이전트 로딩
        if(reload == false) {

          console.log(id, 'id')

          // let rs = await api.webcastle.WebCastle({ target : 'agent', cmd: 'detail', body: { id : id }})
          let rs = await wc.agent.detail({ id : id })
          if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.agent_failed[this.i18n]}`) }
          this.server = Object.assign({}, rs.body, { policy_json : JSON.parse(rs.body.policy) });
          this.setting = Object.assign({}, this.setting, this.server.setting ? JSON.parse(this.server.setting) : {})

          this.get_policy_version()


          // 기본 정책 로딩
          // let rs_crs = await api.webcastle.WebCastle({ target : 'policy', cmd : 'detail', body : { id : this.server.crs_id } });
          let rs_crs = await wc.policy.detail({ id : this.server.crs_id });
          if(rs_crs.error) { return this.$toastr.e(`${i18n_data._i18n_error.policy_failed[this.i18n]}`) }
          this.default_rule = JSON.parse(rs_crs.body.crs_json);
          this.rule_set = JSON.parse(rs_crs.body.crs_json)
          this.crs_rule = Object.assign({}, this.crs_rule, { id : rs_crs.body.id })
          let select_policy = this.crs_version_list[_.findIndex(this.crs_version_list, x => x.id == this.crs_rule.id)]
          if(select_policy) { this.crs_rule = this.target_crs_rule = select_policy }

          console.log("reload policy all")
        }

        // 에이전트 정책 로딩, 처음 기본값 도메인은 default
        let index = _.findIndex(this.server.policy_json.domains, { domain : this.sel_domain.domain } )
        let policy = Object.assign({}, this.policy_default, this.server.policy_json.domains[index])
        // console.log('policy.mode', policy.mode, this.setting)

        // default 도메인의 기본 설정
        policy.mode = policy.mode == codes.WAF_MODE_ON.TEXT ? 2 : (policy.mode == codes.WAF_MODE_DETECTIONONLY.TEXT ? 1 : 0)

        this.setting = Object.assign({}, default_setting(), this.setting, _.pick(policy, ['mode', 'level']));
        this.setting.status = this.server.policy_json.status; // global option

        this.user = default_user();
        this.using_redir = policy.redirection
        this.is_redir = this.using_redir && this.using_redir.length > 0 ? true : false
        try {
          // _.forEach(policy.custom_rule && policy.custom_rule.split('\n'), r => {
          //   if(r.indexOf('SecRuleUpdateActionById 901000-90000000') > -1 && r.match(/redirect:'(.*?)'/).length) {
          //     this.is_redir = true
          //     return
          //   }
          //   if(this.user.custom_rule.indexOf(r) > -1) { return }
          //   this.user.custom_rule += r
          // })
          this.user.custom_rule = policy.custom_rule ? this.base64decode(policy.custom_rule) : ''
          this.user.use_geoip = policy.use_geoip
          this.user.country_code = policy.country_code
          this.user.block_ip = (policy.block_ip || []).join('\n')
          this.user.allow_ip = (policy.allow_ip || []).join('\n')
          this.user.path = (policy.path || []).join('\n')
          this.user.parameter = (policy.parameter || []).join('/')
          this.user.method_control = policy.method_control ? policy.method_control : []
          this.user.method_control.forEach(x => x.ip_list = typeof x.ip_list == typeof '' ? x.ip_list : x.ip_list.join('\n'))
          this.user.use_method = policy.use_method === '' ? false : policy.use_method
        } catch (e) { console.error("load failed", e); this.user = default_user(); }

        // 방화벽 룰별 상세 설정 -> 자식 뷰에서 처리함
        // _.forEach(this.rule_set.rule, r => {
        //   let block_count = 0
        //   _.forEach(r.rules, s => {
        //     this.setting.mode == codes.WAF_MODE_ON.VALUE ? policy.block.push(s.key) : policy.detect.push(s.key)
        //     s.mode = (this.setting.mode == codes.WAF_MODE_ON.VALUE) // block 일 경우만 true
        //     if(s.mode) { block_count += 1 }
        //   })
        //   r.block = block_count
        //   r.detect = r.rules.length - r.block
        //   console.debug('policy', 'r.block', r.block, 'r.detect', r.detect)
        // })

        // 룰 적용
        this.sel_domain = Object.assign({}, this.sel_domain, policy)

        // 이전 하위 호환
        this.filter_rule()

        // console.log(this.user.use_method, this.sel_domain.use_method, 'final')

        this.change_level_value.prev = this.change_level_value.new = this.sel_domain.level
        this.change_mode_value.prev = this.change_mode_value.new = this.setting.mode

        if(this.server.updated_at == this.server.created_at) { this.quick_setting_status = true; this.is_first = true }

        this.loading = false

        this.ping()

        // mmdb 최신 버전 받기
        try {
          let is_dev = location.hostname == 'localhost' || location.hostname.replace('console.', '').startsWith('f1secaas.co.kr') || location.hostname.replace('console.', '').startsWith('f1secaas.net')
          // let rs = await api.webcastle.WebCastleDBLatest(is_dev ? 'develop' : 'release')
          let rs = await wc.WebCastleDBLatest(is_dev ? 'develop' : 'release')
          this.webcastle_mmdb = rs.body
        } catch (e_version) {
          console.log(e_version)
        }

        this.$toastr.i(`${i18n_data._i18n_info.load_success[this.i18n]}`);

        return
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText, `${i18n_data._i18n_error.error_code[this.i18n]}`); }
    },
    getLevel(s) { return s && s.length == 3 ? Number(s.substring(2, 3)) : '-' },
    // 실시간 자원 모니터링, status 로 핑 대체할 수 있음
    res(m) {
      if(m.agent_id != this.server.id) { return;  }
      switch (m.cmd) {
        case "pong":
          this.info = Object.assign({}, this.info, { ms : new Date().getTime() - m.body })
          break;
        case "status":
          this.info = Object.assign({}, this.info, { status : m.body })
          this.info.status.system_cpu_info =  this.info.status.system_cpu_info && typeof this.info.status.system_cpu_info == typeof '' ? JSON.parse(this.info.status.system_cpu_info) : this.info.status.system_cpu_info
          this.info.status.system_disk_info = this.info.status.system_disk_info && typeof this.info.status.system_disk_info == typeof '' ? JSON.parse(this.info.status.system_disk_info) : this.info.status.system_disk_info
          this.info.status.system_memory_info = this.info.status.system_memory_info && typeof this.info.status.system_memory_info == typeof '' ? JSON.parse(this.info.status.system_memory_info) : this.info.status.system_memory_info
          break;
        case "setting.test":
          this.webcastle_alert = true
          this.webcastle_alert_is_error = false
          this.webcastle_alert_msg = m.body.setting_test_info
          // this.webcastle_alert_msg = 'error'
          this.webcastle_alert_is_error = this.webcastle_alert_msg.toLowerCase().indexOf('error') > -1
          console.log("webcastle running", m.body.running, m.body.setting_test_info, 'isError', this.webcastle_alert_is_error)
          break;
        default:
          break;
      }

    },
    async ping(){
      try {
        if(this.ping_th) { clearTimeout(this.ping_th); }
        if(!this.server || !this.server.id) { return }

        agent.Cmd("ping", this.server.id)
        agent.Cmd("status", this.server.id)
        this.ping_th = setTimeout(this.ping, 3000)
      } catch(e) { console.log('ping', e)}
    },
    remove() {
      this.del_nickname = this.del_nickname.trim()
      if(this.server.nickname != this.del_nickname) { return this.$toastr.e(`${i18n_data._i18n_error.servername_check[this.i18n]}`);  }
      // api.webcastle.WebCastle_Call('agent', 'delete', { id : this.server.id }).then(() => this.refresh()).catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText) );
      wc.agent.delete({ id : this.server.id }).then(() => this.refresh()).catch(e => this.$toastr.e(e.data ? n`${i18n_data._i18n_error.remove_failed[this.i18n]}`:  e.data.message ? e.data.message  : e.statusText) );

      this.del_nickname = '';
      this.modal_del = false;

      this.$toastr.e(this.i18n_data['delete'][this.i18n]);

      this.list()
    },
  },
  watch: {
    '$route' (to, from) { console.log("from ", from); this.get(to.params.id); },
  },
  created() {
    console.log('modules.detail.vue', 'created');
    return this.get()

  },
  destroyed() {
    if(this.th) { clearTimeout(this.th); this.th = undefined; console.log("stop sync_log") }
    if(this.ping_th) { clearTimeout(this.ping_th); this.ping_th = undefined; console.log("stop ping & status") }
    console.log('modules.detail.vue', 'destroyed');
    signalr.off('webcastle', this.res);
  },
  mounted() {
    console.log('modules.detail.vue', 'mounted');
    // 개선해야 하는 부분, 한번에 요청 방지
    if(this.th) { clearTimeout(this.th); this.th = undefined; console.log("stop sync_log") }
    if(this.ping_th) { clearTimeout(this.ping_th); this.ping_th = undefined; console.log("stop ping & status") }
    signalr.on('webcastle', this.res)
  },
}
